// extracted by mini-css-extract-plugin
export default {"dropdownSeparator":"iSR2T"};